<template>
  <main class="wrapper">
    <!-- banner -->
    <div class="bg-container"></div>
    <div class="consult-container">
      <div class="consult-body">
        <span class="consult-profile">国内专业的校园大使招募平台，可以为你提供免费、靠谱的大使招募服务。</span>
        <span class="btn-group">
          <a
            href="#recruit-list"
            class="btn btn-apply"
          ><i
              class="iconfont iconxuesheng"
              style="font-size: 18px;color:#fff;margin-right:10px;z-index:99;"
            ></i>应聘校园大使</a>
          <a
            class="btn btn-recruit"
            href="javascript:void(0);"
            @click="recruit"
          >
            <i
              class="iconfont iconweb-icon-"
              style="font-size: 18px;color:#666;margin-right:10px;z-index:99;"
            ></i>
            招募校园大使
          </a>
        </span>
      </div>
    </div>
    <!-- 优势 -->
    <div class="intro-container">
      <p>已助力<span class="num">
          <countTo
            :startVal='startVal'
            :endVal='endVal'
            :duration='2000'
          ></countTo>
        </span>位同学通过平台成功应聘大使职位</p>
      <div class="advantages">
        <i
          class="iconfont iconleftarrow"
          @click="changeIndex(0)"
          style="margin-right: 25px;font-size:25px;color: #cfcfcf;cursor: pointer;"
        ></i>
        <img
          class="img"
          :src="advantages[iconIndex].imgUrl"
          :alt="advantages[iconIndex].title"
        >
        <i
          class="iconfont iconrightarrow"
          @click="changeIndex(1)"
          style="margin-left: 25px;font-size:25px;color: #cfcfcf;cursor: pointer;"
        ></i>
        <div class="advantage-container">
          <p class="step">{{advantages[iconIndex].step}}</p>
          <p class="title">{{advantages[iconIndex].title}}</p>
          <p class="profile">{{advantages[iconIndex].profile}}</p>
          <ul class="icon-list">
            <li
              @click="iconIndex = 0"
              :class="iconIndex === 0?'active': ''"
            ><i class="icon iconfont icon1"></i></li>
            <li
              @click="iconIndex = 1"
              :class="iconIndex === 1?'active': ''"
            ><i class="icon iconfont icon2"></i></li>
            <li
              @click="iconIndex = 2"
              :class="iconIndex === 2?'active': ''"
            ><i class="icon iconfont icon3"></i></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 招募信息 -->
    <div
      id="recruit-list"
      class="recruit-container"
    >
      <div class="recruit-body">
        <p class="recruit-title">招募信息</p>
        <ul class="recruit-list">
          <li
            v-for="(item,index) in recruits"
            :key="index"
          >
            <recruit-item :data="item"></recruit-item>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      :visible.sync="recruitDialog"
      :close-on-click-modal="false"
      :title="'我要招募校园大使'"
      class="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        ref="ruleForm"
        class="form"
        label-position="left"
        label-width="80px"
        :model="formData"
        :rules="rules"
      >
        <el-form-item
          label="公司名称："
          prop="name"
        >
          <el-input v-model="formData.name" />
        </el-form-item>
        <el-form-item
          label="联系人："
          prop="contact"
        >
          <el-input v-model="formData.contact" />
        </el-form-item>
        <el-form-item
          label="联系电话："
          prop="phone"
        >
          <el-input v-model="formData.phone" />
        </el-form-item>
        <el-button
          class="save-btn"
          type="primary"
          @click.native="save"
        >提交招募需求</el-button>
      </el-form>
    </el-dialog>
  </main>
</template>

<script>
import recruitItem from './components/recruit-item'
import server from '@/assets/utils/request.js';
import API from '@/assets/utils/API.js';
import { validPhone } from '@/assets/utils/validate.js'
import countTo from 'vue-count-to';
export default {
  layout: 'campusAmbassador',
  components: {
    recruitItem,
    countTo
  },
  mounted () {
    server.send('GET', API.$RECRUITS, {}).then(res => {
      this.recruits = res.data.data
    })
  },
  data () {
    return {
      iconIndex: 0,
      recruits: [],
      startVal: 0,
      endVal: 3281,
      formData: {
        name: '',
        contact: '',
        phone: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, trigger: 'blur', validator: validPhone }
        ],
      },
      recruitDialog: false,
      advantages: [{
        imgUrl: 'https://img.xiaoguokeji.com/campus_ambassador_advantage1.png',
        step: '01',
        title: '多重审核',
        profile: '51赞助校园大使平台上的信息经过多重审核，层层过滤虚假信息，招募企业经过实名认证，实地认证，安全可靠！'
      },
      {
        imgUrl: 'https://img.xiaoguokeji.com/campus_ambassador_advantage2.png',

        step: '02',
        title: '海量招募',
        profile: 'IT互联网、教育、快消品、游戏电竞...你想要的都在这里。'
      },
      {
        imgUrl: 'https://img.xiaoguokeji.com/campus_ambassador_advantage3.png',
        step: '03',
        title: '毕业求职',
        profile: '获得专属“校园大使证书”，让你的求职路更顺滑。'
      }]
    }
  },
  methods: {
    recruit () {
      this.recruitDialog = true
    },
    closeDialog () {
      this.recruitDialog = false
      this.clearForm()
    },
    changeIndex (flag) {
      if (flag === 0) {
        if (this.iconIndex === 0) {
          this.iconIndex = 2
        } else {
          this.iconIndex = (this.iconIndex - 1) % 3
        }
      } else {
        this.iconIndex = (this.iconIndex + 1) % 3
      }
    },
    save () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          server.send('POST', API.$RECRUITDEMAND, {}, {
            company_name: this.formData.name,
            contact_name: this.formData.contact,
            phone: this.formData.phone,
          }).then(res => {
            this.$message({
              type: 'success',
              message: '信息提交成功！我们会在10分钟内与您联系，请保存电话畅通'
            })
          }).catch(e => {
            this.$message({
              type: 'error',
              message: '提交失败'
            })
          }).finally(() => {
            this.clearForm()
            this.recruitDialog = false
          })
        } else {
          return false;
        }
      })
    },
    clearForm () {
      this.formData.name = ''
      this.formData.phone = ''
      this.formData.contact = ''
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.wrapper {
  .bg-container {
    background: url("https://img.xiaoguokeji.com/campus_ambassador_bg.jpg")
      no-repeat center;
    height: 519px;
  }
  .consult-container {
    height: 76px;
    .consult-body {
      border-bottom: 1px solid #eeeeee;
      height: 100%;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .consult-profile {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .btn-group {
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 196px;
          height: 43px;
          border-radius: 2px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
        .btn-apply {
          background: #00b28a;
          margin-right: 15px;
          color: #ffffff;
        }
        .btn-recruit {
          border: 1px solid #d0d1d3;
          color: #666666;
          background: #ffffff;
        }
      }
    }
  }
  .intro-container {
    p {
      text-align: center;
      margin: 64px 0 0 0;
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 37px;
      .num {
        color: #00b28a;
        font-size: 37px;
      }
    }
    .advantages {
      margin: 118px auto 146px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .img {
        width: 329px;
        height: 292px;
      }
      .advantage-container {
        margin-left: 142px;
        .step {
          margin: 0;
          text-align: center;
          width: 31px;
          height: 20px;
          background: #00b28a;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
        .title {
          margin: 16px 0 0 0;
          width: 112px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
        }
        .profile {
          margin: 14px 0 0 0;
          text-align: left;
          width: 374px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #959595;
          line-height: 22px;
          height: 82px;
        }
        .icon-list {
          margin: 18px 0 0 0;
          padding: 0;
          display: flex;
          list-style: none;
          li {
            cursor: pointer;
            width: 68px;
            height: 68px;
            background: #e6e6e9;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 30px;
            &.active {
              background: #00b28a;
            }
            .icon {
              color: #fff;
              font-size: 28px;
            }
          }
        }
      }
    }
  }
  .recruit-container {
    background: #f6f6f8;
    .recruit-body {
      padding: 31px 0 56px 0;
      width: 1200px;
      margin: 0 auto;
      .recruit-title {
        margin: 0;
        width: 72px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
      }
      .recruit-list {
        margin: 0;
        padding: 0;
        margin-top: 29px;
        list-style: none;
      }
    }
  }
  .showDialog {
    ::v-deep .el-dialog {
      margin-top: 15vh !important;
    }
    ::v-deep .el-form {
      width: 300px;
      margin: auto;
      .el-form-item {
        margin-bottom: 18px;
        .el-form-item__label {
          &::before {
            display: none;
          }
          font-size: 14px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #99a9bf;
          width: 75px !important;
          padding: 0;
          height: 32px;
        }
        .el-form-item__content {
          margin-left: 75px !important;
          .el-input {
            width: 225px;
            .el-input__inner {
              width: 225px;
              height: 30px;
              border: 1px solid rgba(223, 230, 237, 1);
            }
          }
        }
      }
      .save-btn {
        width: 300px;
        height: 40px;
        background: rgba(44, 201, 147, 1);
        border-radius: 2px;
        color: #fff;
      }
    }
  }
}
</style>
